export default {
  titles: {
    email: 'Enter your e-mail',
  },
};
